import { WorkflowRole } from '@exam-management/common/types';
import { WorkflowStepCode } from '@exam-management/graphql';
import type { QuestionCreationWorkflowStepCode } from '@exam-management/task-management';

import { type StartSectionVariant } from './../../containers';

const variant = {
  [WorkflowRole.TASK_OWNER]: {
    [WorkflowStepCode.QuestionCreationTodo]: 'owner',
    [WorkflowStepCode.QuestionCreationInProgress]: 'hidden',
    [WorkflowStepCode.QuestionCreationDone]: 'hidden',
  },
  [WorkflowRole.TASK_ASSIGNEE]: {
    [WorkflowStepCode.QuestionCreationTodo]: 'content-creator',
    [WorkflowStepCode.QuestionCreationInProgress]: 'hidden',
    [WorkflowStepCode.QuestionCreationDone]: 'hidden',
  },
} as const;

export function getStartSectionVariant(
  roles: { isOwner: boolean; isAssignee: boolean },
  workflowStepCode: QuestionCreationWorkflowStepCode,
): StartSectionVariant {
  if (roles.isAssignee) {
    return variant[WorkflowRole.TASK_ASSIGNEE][workflowStepCode];
  }

  if (roles.isOwner) {
    return variant[WorkflowRole.TASK_OWNER][workflowStepCode];
  }

  return 'hidden';
}
